// reportingStructure.js

export const POSITION_ATTRIBUTES = {
  POSITION_ID: 'VwhhrV1ODQK',
  POSITION_TITLE: 'NWe61Sa41CS',
  DEPARTMENT: 'YsGPrrVLAuM',
  JOB_GRADE: 'gp4AnggIDi8',
  POSITION_STATUS: 'Ch7TyL91heU',
  CURRENT_INCUMBENT: 'V66IFsw5kq6',
  PREVIOUS_INCUMBENTS: 'YFmL9BJVJ44',
  REPORTING_TO: 'SjP47qi3JeB',
}

// ⚠️ This is actually a TrackedEntityType ID, NOT a Program ID
export const POSITION_TRACKED_ENTITY_TYPE_ID = 'UGGo0Ebjl0E'

// Query to find user's current position
export const FIND_USER_POSITION_QUERY = {
  trackedEntityInstances: {
    resource: 'trackedEntityInstances',
    params: ({ userId, searchOrgUnit }) => ({
      ouMode: 'ALL', // Search all org units to find user's position
      trackedEntityType: POSITION_TRACKED_ENTITY_TYPE_ID,
      filter: `${POSITION_ATTRIBUTES.CURRENT_INCUMBENT}:EQ:${userId}`,
      fields: 'trackedEntityInstance,orgUnit,attributes[attribute,value]',
      pageSize: 1,
    }),
  },
}

// Find reporting manager for a position
export const findReportingManager = async (positionTei, authHeader, baseUrl) => {
  try {
    console.log(`🔍 Finding reporting manager for position: ${positionTei}`)

    const response = await fetch(
      `${baseUrl}/api/trackedEntityInstances/${positionTei}.json?fields=attributes[attribute,value]`,
      {
        headers: { Authorization: `Basic ${authHeader}` },
      }
    )

    if (!response.ok) {
      throw new Error(`Failed to fetch position: ${response.status}`)
    }

    const positionData = await response.json()

    const reportingToAttr = positionData.attributes?.find(
      (attr) => attr.attribute === POSITION_ATTRIBUTES.REPORTING_TO
    )

    if (!reportingToAttr?.value) {
      console.log('⚠️ No reportingTo attribute found for position')
      return null
    }

    console.log(`📋 Reporting to TEI: ${reportingToAttr.value}`)
    return { tei: reportingToAttr.value }
  } catch (error) {
    console.error('Error finding reporting manager:', error)
    return null
  }
}

// Get TEI's org unit (for non-enrolled TEIs)
export const getTeiOrgUnit = async (tei, authHeader, baseUrl) => {
  try {
    const response = await fetch(
      `${baseUrl}/api/trackedEntityInstances/${tei}.json?fields=orgUnit`,
      {
        headers: { Authorization: `Basic ${authHeader}` },
      }
    )

    if (!response.ok) {
      throw new Error(`Failed to fetch TEI: ${response.status}`)
    }

    const teiData = await response.json()
    return teiData.orgUnit // ✅ Top-level field for standalone TEIs
  } catch (error) {
    console.error('Error getting TEI org unit:', error)
    return null
  }
}